import React, { useEffect, useRef } from 'react';
import ChatMessage from '../UI/ChatMessage';
import AudioPlayer from '../UI/AudioPlayer';
import { Message } from '../../types';

interface ConversationWindowProps {
  messages: Message[];
  remoteStream: MediaStream | null;
  userName?: string;
}

const ConversationWindow: React.FC<ConversationWindowProps> = ({ messages, remoteStream, userName }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Sort messages by sequence to ensure proper order
  const sortedMessages = [...messages].sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));

  return (
    <div className="h-full overflow-y-auto p-4 bg-white">
      {sortedMessages.map(m => (
        <ChatMessage key={`${m.timestamp}-${m.itemId}`} message={m} userName={userName} />
      ))}
      <div ref={messagesEndRef} />
      <AudioPlayer stream={remoteStream} />
    </div>
  );
};

export default ConversationWindow;
